module.exports = __webpack_public_path__ + "static/WazirX-f9924e15b31ca88f11d37bde82dd1c74.png";